<template>
  <div>
    <component
      :is="components[resource.template]"
      :key="route.fullPath"
      :content="content"
    />
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'

import { useResourceStore } from '@/stores/resource'
import Notfound from '@/views/404.vue'
import AllBrands from '@/views/pages/AllBrands.vue'
import Contact from '@/views/pages/Contact.vue'
import Default from '@/views/pages/Default.vue'
import Faq from '@/views/pages/Faq.vue'
import Landing from '@/views/pages/Landing.vue'
import Legacy from '@/views/pages/Legacy.vue'
import Services from '@/views/pages/Services.vue'
import Showroom from '@/views/pages/Showroom.vue'

import type { Component } from 'vue'

defineProps({
  content: {
    type: Object,
    required: true,
  },
})

const route = useRoute()
const resource = useResourceStore()

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const components: { [key: string]: Component } = {
  notfound: Notfound,
  showroom: Showroom,
  legacy: Legacy,
  services: Services,
  diplomatic: Services,
  contact: Contact,
  faq: Faq,
  brands: AllBrands,
  'landing-page': Landing,
  page: Default,
}
</script>
